export const ENHANCED = 'enhanced';
export const UNENHANCED = 'unenhanced';
export const GENERIC = 'generic';
